import { Product, WishListResponse } from '../interface/interface';
import ProductCards from './ProductCards';

interface HomeProductsProps {
  products: any[];
  totalProducts: number;
  addProductToCart: (id: string) => Promise<void>;
  removeProductFromCart: (id: string) => Promise<void>;
  wishListProducts: Array<WishListResponse>;
}

const HomeProducts = (props: HomeProductsProps) => {
  const { products, addProductToCart, removeProductFromCart } = props;

  return (
    <>
      {products.map((product: Product, index: number) => (
        <div key={index} className="flex flex-col h-full">
          <ProductCards
            product={product}
            addProductToCart={addProductToCart}
            removeProductFromCart={removeProductFromCart}
            isAccessories={false}
            allowedProduct={Boolean(product?.allowedProducts?.length)}
            isGuest={false}
            wishListProducts={props.wishListProducts}
          />
        </div>
      ))}
    </>
  );
};

export default HomeProducts;
